import { render, staticRenderFns } from "./login-overseas.vue?vue&type=template&id=1eb7021b"
import script from "./login-overseas.vue?vue&type=script&lang=js"
export * from "./login-overseas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports